// @ts-nocheck
import Button from 'atoms/button/button';
import Heading from 'atoms/heading/heading';
import ModalActions from 'atoms/modal/modalActions';
import ModalBody from 'atoms/modal/modalBody';
import * as dynamicGridSelectors from 'models/dynamicGrid/selector';
import Stack from 'molecules/stack/stack';
import StackItem from 'molecules/stackItem/stackItem';
import * as adModalSelectors from 'pages/advertising/adModal/selector';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate } from 'utils/utils';

import { AD_MODAL_TABLE_IDS } from './constants';
import { createNewAdvertising } from './sagaActions';
import { Tprops } from './types';
import moment from 'moment';

const ReviewAd = (props: Tprops) => {
	const { hideModal, handleNextClick, goBack } = props;
	const dispatch = useDispatch();

	const selectedStores = useSelector((state) =>
		dynamicGridSelectors.getTableSelection(state, AD_MODAL_TABLE_IDS.STORES)
	);
	const selectedSkus = useSelector((state) => dynamicGridSelectors.getTableSelection(state, AD_MODAL_TABLE_IDS.SKUS));
	const pricingTableData =
		useSelector((state) => dynamicGridSelectors.getGridData(state, AD_MODAL_TABLE_IDS.ENTER_PRICING)) || [];
	const adData: any = useSelector((state) => adModalSelectors.getAdModalData(state, 'advertising')) || {};
	const isEditMode: boolean = useSelector((state) => adModalSelectors.getEditMode(state)) || false;
	const editData: any = useSelector((state) => adModalSelectors.getEditData(state)) || {};
	const getInputData = (attribute: string) => {
		let inputData = [];
		for (let item of pricingTableData) {
			if (item[attribute]) {
				inputData.push(item[attribute].toString());
			}
		}
		return inputData.join(',');
	};

	const handleSaveAdClick = async (e: any) => {
		localStorage.removeItem('selectAllSkusCount');
		localStorage.removeItem('selectAllStoresCount');
		const { EndDate, StartDate, LoadDate, ...restAdData } = adData;
		let data = {
			...restAdData,
			StartDate: moment(StartDate).format('MM-DD-YYYY'),
			EndDate: moment(EndDate).format('MM-DD-YYYY'),
			LoadDate: moment(LoadDate).format('MM-DD-YYYY'),
			AdCostList: getInputData('AdCost'),
			MinOrderQtyList: getInputData('MinOrderQty'),
			SKUIDList:
				selectedSkus &&
				selectedSkus?.selectedRowKeys &&
				selectedSkus?.selectedRowKeys.length &&
				selectedSkus?.selectedRowKeys.join(','),
			StoreIDList:
				selectedStores &&
				selectedStores?.selectedRowKeys &&
				selectedStores?.selectedRowKeys.length &&
				selectedStores?.selectedRowKeys.join(','),
		};
		if (isEditMode) {
			dispatch(createNewAdvertising({ AdID: editData[0].AdID }));
		} else {
			dispatch(createNewAdvertising());
		}
		// handleNextClick(e);
	};

	return (
		<>
			<ModalBody>
				<Stack isVertical gutter="medium">
					<StackItem isStretch isGrow>
						<Stack isVertical gutter="medium">
							<StackItem isStretch>
								<Heading type="secondary">
									Your ad starts on {moment(adData.StartDate).format('MM-DD-YYYY')} and ends on{' '}
									{moment(adData.EndDate).format('MM-DD-YYYY')}.
								</Heading>
							</StackItem>
							<StackItem isStretch>
								<Heading type="secondary">
									This ad is for{' '}
									{selectedSkus?.isSelectAll
										? localStorage.getItem('selectAllSkusCount')
										: selectedSkus?.selectedRowKeys?.length}{' '}
									SKUs in{' '}
									{selectedStores?.isSelectAll
										? localStorage.getItem('selectAllStoresCount')
										: selectedStores?.selectedRowKeys?.length}{' '}
									store.
								</Heading>
							</StackItem>
						</Stack>
					</StackItem>
				</Stack>
			</ModalBody>
			<ModalActions>
				<Stack gutter="medium">
					<StackItem isStretch isGrow>
						<Stack align="left" gutter="small">
							<StackItem>
								<Button isSecondary name="Re-Select Pricing" handleClick={goBack} />
							</StackItem>
						</Stack>
					</StackItem>
					<StackItem>
						<Stack align="right" gutter="small">
							<StackItem>
								<Button isText name="Cancel" handleClick={hideModal} />
							</StackItem>
							<StackItem isStretch align="right">
								<Button isPrimary name={'Save Ad'} handleClick={handleSaveAdClick} />
							</StackItem>
						</Stack>
					</StackItem>
				</Stack>
			</ModalActions>
		</>
	);
};

export default ReviewAd;
